import deps from "../depsloader";

export default () => {
  const buttons = document.querySelectorAll("a[href$='#wertermittlung']");
  if (!buttons) return;

  deps.load("lightgallery").then(() => {
    for (const btn of buttons) {
      btn.href = 'https://forms.iib-it.de/wma-form/brammen-immobilien/index.html';
      btn.dataset.src = 'https://forms.iib-it.de/wma-form/brammen-immobilien/index.html';
      btn.dataset.iframe = true;

      lightGallery(btn, { //eslint-disable-line
        selector: 'this',
        iframeMaxWidth: '80%',
        download: false
      });
    }
  });
}
